---
label: BLAST Search
category: analysis
icon: SearchIcon
keywords: [blast, search, homology, blastn, blastp, blastx, tblastn, tblastx, ncbi]
addedInVersion: "0.0.0"
---

# BLAST Search

Search NCBI databases for sequences similar to yours.

## Starting a Search

Open a sequence and click the **BLAST** button in the toolbar. Choose **New
Search** to open the search dialog.

You can search using the full sequence or a selected region.

## Options

- **Program** — blastn, blastp, blastx, tblastn, or tblastx.
- **Database** — changes based on the selected program. Nucleotide programs
  search against databases like nt and RefSeq. Protein programs search nr,
  SwissProt, PDB, and others.
- **E-value** — maximum expect value for reported hits.
- **Max Hits** — maximum number of hits to return (up to 5000).

## Results

Results appear as a table of hits with accession, description, bit score,
e-value, identity, and coverage. Click a row to expand the alignment detail
showing each high-scoring segment pair.

Previous searches are listed in the **Searches** tab. Searches that become stale
(because the sequence was edited) can be re-run from there.

## NCBI Credentials

NCBI limits unauthenticated requests to 3 per second. With an API key, the
limit increases to 10 per second and searches are less likely to be throttled.

You can get a free API key by creating an
[NCBI account](https://www.ncbi.nlm.nih.gov/account/). The key is available in
your account settings. Enter it along with your NCBI email in
[Services Settings](/settings/services).
